/* */
import { filterDidsInitial } from 'consts/filters';
import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import actions from 'redux/actions';

const { getListDidGroup } = actions;

//* get list to select from phone
export default (filters = filterDidsInitial) => {
  const authReducer = useSelector((state) => state.authReducer, shallowEqual);

  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      dispatch(getListDidGroup({ filters }));
    }
  }, [authReducer.isLogin]);
};
